export default "__VITE_ASSET__1a0c4866__"